var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.022,
    height: 13.443,
    viewBox: "0 0 23.022 13.443",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M20.889,168.043H34.424a4.582,4.582,0,0,0,.886-9.078,5.237,5.237,0,0,0-5.156-4.364,5.084,5.084,0,0,0-3.668,1.518,4.356,4.356,0,0,0-1.266-.19,4.266,4.266,0,0,0-3.8,2.339,3.88,3.88,0,0,0-.537-.062,4.919,4.919,0,0,0,0,9.837Zm0-7.937a2.35,2.35,0,0,1,.821.127l.949.285.252-.949a2.362,2.362,0,0,1,2.277-1.77,2.3,2.3,0,0,1,1.106.285l.726.379.474-.632a3.279,3.279,0,0,1,2.657-1.328,3.354,3.354,0,0,1,3.353,3.353v.949h.949a2.67,2.67,0,1,1-.027,5.34H20.889a3.02,3.02,0,0,1,0-6.039Z",
    transform: "translate(-15.988 -154.6)",
    fill: "#222631"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.8877cf7fd5b1092d694e055d7d13f5d2.svg";
export { ForwardRef as ReactComponent };